import React from "react";
import { Box, Paper, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import LockIcon from "@material-ui/icons/Lock";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "60vh",
  },
  paper: {
    padding: theme.spacing(6),
    maxWidth: 520,
    textAlign: "center",
  },
  icon: {
    fontSize: 48,
    color: "#7C8DB5",
    marginBottom: theme.spacing(2),
  },
  title: {
    fontWeight: 700,
    marginBottom: theme.spacing(1),
    color: "#3A4D54",
  },
  body: {
    color: "#7C8DB5",
  },
}));

export default function NoAccessPage() {
  const classes = useStyles();
  return (
    <Box className={classes.root}>
      <Paper className={classes.paper} elevation={0}>
        <LockIcon className={classes.icon} />
        <Typography variant="h6" className={classes.title}>
          No features available yet
        </Typography>
        <Typography variant="body2" className={classes.body}>
          Your account hasn't been granted access to any features. Please contact your admin to get started.
        </Typography>
      </Paper>
    </Box>
  );
}
